// extracted by mini-css-extract-plugin
var _1 = "#0078d3";
var _2 = "#0a4789";
var _3 = "1rem";
var _4 = "0px solid #B5BEC9";
var _5 = "#0078d3";
var _6 = "#202328";
var _7 = "#202328";
var _8 = "#1c4785";
var _9 = "#0078d3";
var _a = "#9fa8b6";
var _b = "#0078d3";
var _c = "#7a7a7a";
var _d = "0";
var _e = "#CCEEE4";
var _f = "#00573E";
var _10 = "#0078d3";
var _11 = "#202328";
var _12 = "#C6DEF2";
var _13 = "#3f51b5";
var _14 = "#0078d3";
var _15 = "#202328";
var _16 = "#202328";
var _17 = "#0078d3";
var _18 = "#2D2D2D";
var _19 = "#FFFFFF";
var _1a = "#E4FBDF";
var _1b = "#00573E";
var _1c = "#FED6D9";
var _1d = "#811B1F";
var _1e = "'Roboto', 'Segoe UI Web (West European)'";
var _1f = "normal";
var _20 = "normal";
var _21 = "#E2C7E9";
var _22 = "#5E296D";
var _23 = "#dee3ec";
var _24 = "#c4c9d2";
var _25 = "#dee3ec";
var _26 = "#738188";
var _27 = "#c4cbd4";
var _28 = "#9fa8b6";
var _29 = "#9fa8b6";
var _2a = "#0078d3";
var _2b = "#0078D3";
var _2c = "#99A3B4";
var _2d = "#FDE6D3";
var _2e = "#7F4313";
var _2f = "#E0E5EE";
var _30 = "#373E40";
var _31 = "#0078d3";
var _32 = "#0078d3";
var _33 = "$searchfield-xmark-color";
var _34 = "#DEEDF7";
var _35 = "#2E5670";
var _36 = "#4E7A99";
var _37 = "geotab";
var _38 = "1.1";
var _39 = "#4E677E";
export { _1 as "activeButtonBackgroundColor", _2 as "activeButtonHoverBackgroundColor", _3 as "autocompleteFontSize", _4 as "borderBottomCard", _5 as "buttonCancelBackground", _6 as "buttonDarkBackground", _7 as "buttonDarkTypography", _8 as "buttonHover", _9 as "buttonHoverBackgroundColor", _a as "buttonLightGreyBackground", _b as "buttonSubmitBackground", _c as "closeIconColor", _d as "closeIconMarginBottom", _e as "completedStatusIndicatorBackground", _f as "completedStatusIndicatorColor", _10 as "customColor1", _11 as "customColor2", _12 as "customColor4", _13 as "customColor5", _14 as "customColor6", _15 as "customColor9", _16 as "darkTypography", _17 as "deviceAssociationsDelete", _18 as "dismissedStatusIndicatorBackground", _19 as "dismissedStatusIndicatorColor", _1a as "driverAcceptedStatusIndicatorBackground", _1b as "driverAcceptedStatusIndicatorColor", _1c as "driverDisputedStatusIndicatorBackground", _1d as "driverDisputedStatusIndicatorColor", _1e as "fontFamily", _1f as "fontWeight", _20 as "fontWeight1", _21 as "inProgressStatusIndicatorBackground", _22 as "inProgressStatusIndicatorColor", _23 as "inactiveBackgroundColor", _24 as "inactiveIconColor", _25 as "inactiveThumbnailBackgroundColor", _26 as "inactiveThumbnailTextColor", _27 as "lightGrey", _28 as "lightGreySecondary", _29 as "lightGreyTypography", _2a as "mainBlue", _2b as "multiSelectSwitchBaseCheckedColor", _2c as "multiSelectSwitchTrackColor", _2d as "newStatusIndicatorBackground", _2e as "newStatusIndicatorColor", _2f as "noResponseStatusIndicatorBackground", _30 as "noResponseStatusIndicatorColor", _31 as "radioButton", _32 as "radioButtonChecked", _33 as "searchFieldXmarkColor", _34 as "sentToDriverStatusIndicatorBackground", _35 as "sentToDriverStatusIndicatorColor", _36 as "steelBlue", _37 as "styleEnvironment", _38 as "textCardDescriptionLineHeight", _39 as "videoEventFilterSelectIconColor" }
